// Page-level translations for Construction, Export and Technology pages.
// Fully populated for all 7 supported locales: TR, EN, AR, ES, RU, DE, FR.

import { translations as base } from "./translations";

const NAV_EXTRA = {
  tr: { construction: "İnşaat", export: "İhracat", technology: "Teknoloji", team: "Ekibimiz" },
  en: { construction: "Construction", export: "Export", technology: "Technology", team: "Our Team" },
  ar: { construction: "الإنشاءات", export: "التصدير", technology: "التكنولوجيا", team: "فريقنا" },
  es: { construction: "Construcción", export: "Exportación", technology: "Tecnología", team: "Equipo" },
  ru: { construction: "Строительство", export: "Экспорт", technology: "Технологии", team: "Команда" },
  de: { construction: "Bau", export: "Export", technology: "Technologie", team: "Team" },
  fr: { construction: "Construction", export: "Exportation", technology: "Technologie", team: "Équipe" },
};

// Inject extra nav keys into base translations so Navbar/Footer pick them up.
Object.keys(NAV_EXTRA).forEach((loc) => {
  if (base[loc] && base[loc].nav) {
    Object.assign(base[loc].nav, NAV_EXTRA[loc]);
  }
});

export const PAGES = {
  // ─────────────────────────────────────────────────────────── TR
  tr: {
    construction: {
      eyebrow: "İNŞAAT",
      hero: {
        title: "Tasarımdan teslime kurumsal inşaat çözümleri.",
        subtitle:
          "Konut, ticari ve endüstriyel projelerde dizayn, danışmanlık, projelendirme ve imalat hizmetlerini tek çatı altında sunuyoruz.",
        cta: "Proje Brifi Paylaşın",
      },
      services: {
        title: "İnşaat Hizmetlerimiz",
        lead: "Her aşamada disiplinli yönetim ve uluslararası standartlar.",
        items: [
          {
            key: "design",
            title: "Dizayn",
            desc: "Mimari konsept, iç mekan tasarımı, peyzaj ve görselleştirme. Her projede estetik, işlevsellik ve sürdürülebilirlik dengesi.",
            features: [
              "Mimari konsept ve avan proje",
              "İç mimari ve mekan tasarımı",
              "Peyzaj ve dış mekan tasarımı",
              "3D görselleştirme ve render",
              "Aydınlatma ve akustik tasarım",
            ],
          },
          {
            key: "consulting",
            title: "Danışmanlık",
            desc: "Fizibilite, ruhsat, proje yönetim danışmanlığı, sözleşme ve risk yönetimi ile yatırımlarınızı güvence altına alıyoruz.",
            features: [
              "Fizibilite ve maliyet analizi",
              "Ruhsat ve mevzuat danışmanlığı",
              "Proje yönetim danışmanlığı (PMC)",
              "Sözleşme ve ihale yönetimi",
              "Risk ve kalite denetimi",
            ],
          },
          {
            key: "engineering",
            title: "Projelendirme",
            desc: "Statik, mekanik, elektrik ve altyapı projeleri. BIM tabanlı entegre koordinasyon ve uygulama detayları.",
            features: [
              "Statik ve betonarme projelendirme",
              "Mekanik tesisat (HVAC, sıhhi)",
              "Elektrik ve zayıf akım projeleri",
              "BIM koordinasyonu",
              "Yapısal analiz ve hesap raporları",
            ],
          },
          {
            key: "manufacturing",
            title: "İmalat",
            desc: "Çelik konstrüksiyon, prefabrik elemanlar, cephe sistemleri ve özel mobilya imalatı; saha kurulum ve teslim dahil.",
            features: [
              "Çelik konstrüksiyon imalat",
              "Prefabrik betonarme elemanlar",
              "Cephe ve doğrama sistemleri",
              "Özel mobilya ve dekorasyon",
              "Saha montaj ve devreye alma",
            ],
          },
        ],
      },
      cta: {
        title: "Projenizi konuşalım.",
        body: "Brifinizi paylaşın, ekibimiz teknik fizibilite ve teklif için 1 iş günü içinde dönüş yapsın.",
        button: "İletişime Geçin",
      },
    },
    export: {
      eyebrow: "İHRACAT",
      hero: {
        title: "Türk mallarının yabancı alıcılarla buluştuğu güvenli köprü.",
        subtitle:
          "Yabancı yatırımcı ve alıcılar adına Türkiye genelinde ürün araştırma, tedarikçi seçimi, kalite kontrol ve uçtan uca ihracat operasyonu sağlıyoruz.",
        cta: "Talep Formu",
      },
      services: {
        title: "İhracat Hizmetlerimiz",
        lead: "Yabancı alıcılar için Türkiye'den profesyonel kaynak yönetimi.",
        items: [
          { title: "Ürün Araştırma & Bulma", desc: "İhtiyacınız olan Türk menşeili ürünleri sektör uzmanlarıyla araştırır, en uygun üreticileri ve tedarikçileri kısa sürede listeleriz." },
          { title: "Tedarikçi Doğrulama & Seçim", desc: "Saha ziyareti, finansal güvenilirlik kontrolü, sertifika doğrulama ve referans incelemesiyle güvenilir tedarikçi seçimi." },
          { title: "Tedarik & Numune Yönetimi", desc: "Numune temini, tedarik müzakeresi, fiyat optimizasyonu, ödeme şartları ve sözleşme yönetimi." },
          { title: "Kalite Kontrol & Denetim", desc: "Üretim öncesi, üretim sırası ve sevkiyat öncesi kalite kontrolleri (ISO uyumlu denetim)." },
          { title: "İhracat Operasyonu", desc: "Gümrük, lojistik, sigorta, akreditif ve uluslararası taşımacılık dahil uçtan uca ihracat süreç yönetimi." },
          { title: "Belgeleme & Uyum", desc: "Menşei sertifikası, fatura, sevk irsaliyesi, ATR/EUR.1, sağlık ve uygunluk belgeleri." },
        ],
      },
      form: {
        title: "Talep Formu",
        lead: "İhtiyacınız olan ürün veya hizmet hakkında detayları paylaşın, size özel teklif hazırlayalım.",
        labels: {
          fullName: "Ad Soyad", email: "E-posta", phone: "Telefon", company: "Şirket", country: "Ülkeniz",
          productCategory: "Ürün Kategorisi", productDetails: "Ürün Detayları / Spesifikasyon",
          quantity: "Miktar", targetMarket: "Hedef Pazar", timeline: "İhtiyaç Zaman Çizelgesi",
          budgetRange: "Bütçe Aralığı (opsiyonel)", notes: "Ek Notlar",
        },
        placeholders: {
          productCategory: "Örn. Tekstil, gıda, makine, mobilya, inşaat malzemesi...",
          productDetails: "Aradığınız ürünün detaylarını, kalite seviyesini, marka tercihlerini yazın.",
          quantity: "Örn. 1.000 adet / ay, 20 ton, 1 konteyner",
          timeline: "Örn. 4-6 hafta",
          budgetRange: "Örn. 50.000 - 100.000 USD",
        },
        submit: "Talep Gönder", submitting: "Gönderiliyor...",
        successTitle: "Talebiniz alındı", successBody: "İhracat ekibimiz 1 iş günü içinde size detaylı teklifle dönüş yapacaktır.",
        errorTitle: "Bir hata oluştu", errorBody: "Lütfen tekrar deneyin.",
        confidential: "Ticari bilgileriniz tamamen gizli tutulur.",
      },
    },
    technology: {
      eyebrow: "TEKNOLOJİ",
      hero: {
        title: "Siber güvenlik, yazılım ve yapay zeka — tek bir teknoloji ortağı.",
        subtitle:
          "Penetrasyon ve DDoS testlerinden kurumsal yazılım geliştirmeye, yapay zeka çözümlerinden yazılım kalitesine kadar uçtan uca teknoloji hizmetleri.",
        cta: "Teknik Görüşme",
      },
      categories: [
        {
          key: "cyber",
          title: "Siber Güvenlik & Sızma Testleri",
          lead: "Saldırgan bakış açısıyla altyapınızı test eder, savunmanızı güçlendiririz.",
          items: [
            { title: "Penetrasyon Testi (Web)", desc: "OWASP Top 10 ve ötesi: SQLi, XSS, RCE, IDOR, SSRF, kimlik doğrulama zafiyetleri." },
            { title: "Penetrasyon Testi (Mobil)", desc: "iOS / Android uygulamalarında ters mühendislik, jailbreak/root tespiti, depolama güvenliği." },
            { title: "Penetrasyon Testi (Ağ)", desc: "İç ve dış ağ pentest, segmentasyon testi, AD/Active Directory zafiyet analizi." },
            { title: "Penetrasyon Testi (API)", desc: "REST/GraphQL API'lerinde yetkilendirme, hız sınırlama, veri sızıntısı analizleri." },
            { title: "DDoS Testi & Direnç", desc: "Volumetric, protokol ve uygulama katmanı DDoS senaryolarıyla altyapınızın direncini ölçer." },
            { title: "Bulut Güvenliği (AWS/Azure/GCP)", desc: "IAM, S3/Blob/GCS yapılandırma denetimi, KMS, CIS benchmark uyumu." },
            { title: "Red Team & Adversary Simulation", desc: "MITRE ATT&CK çerçevesiyle kurumsal saldırı simülasyonu ve TTP testleri." },
            { title: "Sosyal Mühendislik & Phishing", desc: "Hedefli phishing, spear-phishing, vishing kampanyaları ve farkındalık ölçümü." },
            { title: "Kaynak Kod Güvenlik Analizi (SAST)", desc: "Statik analiz, secret tarama, bağımlılık (SCA) güvenlik denetimi." },
            { title: "DAST & IAST", desc: "Dinamik ve etkileşimli uygulama güvenlik testleri canlı ortamlarda." },
            { title: "Vulnerability Management", desc: "Tarama, önceliklendirme, yamalama ve doğrulama döngüsü." },
            { title: "SOC / SIEM Hizmetleri", desc: "7/24 izleme, log toplama, korelasyon, alarm yönetimi." },
            { title: "Olay Müdahale & Adli Bilişim", desc: "Incident response, malware analizi, dijital kanıt toplama ve raporlama." },
            { title: "ISO 27001 / KVKK / GDPR Uyumu", desc: "Boşluk analizi, politika, prosedür ve denetim hazırlığı." },
            { title: "Güvenli SDLC & DevSecOps", desc: "CI/CD hattına güvenlik tarama entegrasyonu, IaC güvenliği." },
          ],
        },
        {
          key: "software",
          title: "Yazılım Geliştirme",
          lead: "Web, mobil ve kurumsal yazılım çözümleri — modern, ölçeklenebilir, güvenli.",
          items: [
            { title: "Website Geliştirme", desc: "Kurumsal siteler, e-ticaret, headless CMS, performans odaklı (Lighthouse 90+)." },
            { title: "Mobil Uygulama Geliştirme", desc: "iOS, Android ve cross-platform (React Native / Flutter) uygulamaları." },
            { title: "Web Uygulama Geliştirme", desc: "SaaS, dashboard, B2B portal, gerçek zamanlı uygulamalar." },
            { title: "Kurumsal Yazılım & ERP", desc: "Özel ERP, CRM, iş akışı yönetimi entegrasyonları." },
            { title: "API & Mikroservis Mimarisi", desc: "REST, GraphQL, gRPC; event-driven mimariler ve servis mesh." },
            { title: "Bulut & DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), gözlemlenebilirlik." },
            { title: "Yazılım Modernizasyonu", desc: "Legacy sistemlerin yeniden yapılandırılması ve buluta taşınması." },
            { title: "Yazılım Koruma & Lisanslama", desc: "Anti-tamper, kod obfuscation, DRM, lisans sunucusu çözümleri." },
          ],
        },
        {
          key: "qa",
          title: "Yazılım Testleri & Kalite Güvencesi",
          lead: "Üretime çıkmadan önce her senaryo, her yük, her uç durum kontrol altında.",
          items: [
            { title: "Manuel & Keşif Testi", desc: "Deneyimli QA mühendisleriyle senaryo bazlı manuel testler." },
            { title: "Otomasyon Testi", desc: "Selenium, Cypress, Playwright, Appium ile uçtan uca otomasyon." },
            { title: "Performans & Yük Testi", desc: "JMeter, k6, Locust ile gerçekçi yük senaryoları ve darboğaz analizi." },
            { title: "Güvenlik Testi", desc: "OWASP, ZAP, Burp Suite ile uygulama güvenlik testleri." },
            { title: "API Testi", desc: "Postman, REST Assured, Karate ile fonksiyonel ve entegrasyon testleri." },
            { title: "Mobil Cihaz Lab Testi", desc: "Gerçek cihaz havuzunda iOS/Android uyumluluk testleri." },
            { title: "Erişilebilirlik (a11y) Testi", desc: "WCAG 2.1 / 2.2 AA uyumu kontrolü ve onarım önerileri." },
            { title: "Kullanıcı Kabul Testi (UAT)", desc: "İş tarafıyla birlikte UAT planlama ve yürütme." },
            { title: "Regresyon Testi", desc: "Akıllı regresyon stratejisi ve sürüm güvencesi." },
          ],
        },
        {
          key: "ai",
          title: "Yapay Zeka & Veri",
          lead: "Üretken yapay zeka, makine öğrenmesi ve veri çözümleri ile geleceği bugün kurun.",
          items: [
            { title: "Üretken Yapay Zeka (GenAI)", desc: "LLM tabanlı sohbet botları, asistanlar, içerik üretim sistemleri." },
            { title: "RAG & Bilgi Tabanı Asistanları", desc: "Kurumsal bilgi tabanı + LLM ile özel sorgu motorları." },
            { title: "Makine Öğrenmesi (ML)", desc: "Tahminleme, sınıflandırma, anomali tespiti, tavsiye sistemleri." },
            { title: "Bilgisayarlı Görü", desc: "Nesne tespiti, OCR, kalite kontrol, yüz/tehdit tanıma." },
            { title: "Doğal Dil İşleme (NLP)", desc: "Duygu analizi, konu modelleme, çeviri, özetleme." },
            { title: "AI Test ve Değerlendirme", desc: "Model doğruluk, sapma (bias), güvenlik (jailbreak) testleri ve değerlendirme." },
            { title: "MLOps & Veri Pipeline", desc: "Model dağıtım, izleme, yeniden eğitim ve veri yönetimi." },
            { title: "Veri Mühendisliği & Analitik", desc: "Veri ambarı, ETL, gerçek zamanlı analitik, BI dashboard." },
          ],
        },
      ],
      cta: {
        title: "Teknolojinizi güçlendirelim.",
        body: "İhtiyacınızı bize iletin — siber güvenlik, yazılım veya AI projeniz için ücretsiz keşif görüşmesi planlayalım.",
        button: "Bize Ulaşın",
      },
    },
  },

  // ─────────────────────────────────────────────────────────── EN
  en: {
    construction: {
      eyebrow: "CONSTRUCTION",
      hero: {
        title: "Corporate construction solutions, from design to delivery.",
        subtitle: "Design, consulting, engineering and manufacturing — under one roof for residential, commercial and industrial projects.",
        cta: "Share Your Brief",
      },
      services: {
        title: "Our Construction Services",
        lead: "Disciplined management at every stage with international standards.",
        items: [
          { key: "design", title: "Design", desc: "Architectural concept, interior design, landscape and visualization — balancing aesthetics, function and sustainability.", features: ["Architectural concept & schematic design", "Interior architecture", "Landscape & exterior design", "3D visualization and rendering", "Lighting and acoustics design"] },
          { key: "consulting", title: "Consulting", desc: "Feasibility, permits, project management consulting, contract and risk management to safeguard your investment.", features: ["Feasibility and cost analysis", "Permits and regulatory advisory", "Project management consulting (PMC)", "Contract and tender management", "Risk and quality oversight"] },
          { key: "engineering", title: "Engineering", desc: "Structural, mechanical, electrical and infrastructure engineering with BIM-based integrated coordination.", features: ["Structural & RC engineering", "MEP (HVAC, plumbing)", "Electrical and ELV engineering", "BIM coordination", "Structural analysis & calculation reports"] },
          { key: "manufacturing", title: "Manufacturing", desc: "Steel structures, precast elements, façade systems and custom millwork; site installation and handover included.", features: ["Steel structure manufacturing", "Precast concrete elements", "Façade and joinery systems", "Custom millwork and decoration", "On-site installation and commissioning"] },
        ],
      },
      cta: { title: "Let's discuss your project.", body: "Share your brief and our team will respond with technical feasibility and a proposal within 1 business day.", button: "Contact Us" },
    },
    export: {
      eyebrow: "EXPORT",
      hero: {
        title: "A trusted bridge between Turkish products and global buyers.",
        subtitle: "We source, qualify and procure Turkish-made products on behalf of foreign buyers — handling end-to-end export operations.",
        cta: "Request Form",
      },
      services: {
        title: "Our Export Services",
        lead: "Professional Türkiye sourcing for foreign buyers.",
        items: [
          { title: "Product Research & Sourcing", desc: "We research Turkish-origin products and shortlist the most suitable manufacturers and suppliers." },
          { title: "Supplier Verification", desc: "On-site visits, financial credibility checks, certification verification and reference reviews." },
          { title: "Procurement & Sampling", desc: "Sample procurement, negotiation, price optimization, payment terms and contracts." },
          { title: "Quality Control & Audit", desc: "Pre-production, in-production and pre-shipment QC (ISO-aligned audits)." },
          { title: "Export Operations", desc: "Customs, logistics, insurance, LC and international freight — full export process management." },
          { title: "Documentation & Compliance", desc: "Certificate of origin, invoice, packing list, ATR/EUR.1, health and conformity certificates." },
        ],
      },
      form: {
        title: "Request Form",
        lead: "Share details about the products or services you need and we will prepare a tailored proposal.",
        labels: { fullName: "Full name", email: "Email", phone: "Phone", company: "Company", country: "Your country", productCategory: "Product category", productDetails: "Product details / specification", quantity: "Quantity", targetMarket: "Target market", timeline: "Timeline", budgetRange: "Budget range (optional)", notes: "Additional notes" },
        placeholders: { productCategory: "e.g. Textile, food, machinery, furniture, building materials...", productDetails: "Describe the product, quality level, brand preferences.", quantity: "e.g. 1,000 units / month, 20 tons, 1 container", timeline: "e.g. 4-6 weeks", budgetRange: "e.g. 50,000 - 100,000 USD" },
        submit: "Send Request", submitting: "Sending...",
        successTitle: "Request received", successBody: "Our export team will respond with a detailed proposal within 1 business day.",
        errorTitle: "Something went wrong", errorBody: "Please try again.",
        confidential: "Your commercial information remains strictly confidential.",
      },
    },
    technology: {
      eyebrow: "TECHNOLOGY",
      hero: {
        title: "Cybersecurity, software and AI — one technology partner.",
        subtitle: "From penetration and DDoS testing to enterprise software, AI solutions and software quality — a complete technology stack.",
        cta: "Talk to Us",
      },
      categories: [
        {
          key: "cyber", title: "Cybersecurity & Penetration Testing",
          lead: "We test your infrastructure with an attacker mindset and harden your defenses.",
          items: [
            { title: "Web Penetration Testing", desc: "OWASP Top 10 and beyond: SQLi, XSS, RCE, IDOR, SSRF, authentication issues." },
            { title: "Mobile Penetration Testing", desc: "iOS / Android reverse engineering, jailbreak/root detection, storage security." },
            { title: "Network Penetration Testing", desc: "Internal & external pentest, segmentation testing, AD vulnerability analysis." },
            { title: "API Penetration Testing", desc: "Authorization, rate limiting and data leakage analysis on REST/GraphQL APIs." },
            { title: "DDoS Testing & Resilience", desc: "Volumetric, protocol and application-layer DDoS scenarios to measure resilience." },
            { title: "Cloud Security (AWS/Azure/GCP)", desc: "IAM, S3/Blob/GCS configuration audits, KMS, CIS benchmark compliance." },
            { title: "Red Team & Adversary Simulation", desc: "MITRE ATT&CK based adversary simulation and TTP testing." },
            { title: "Social Engineering & Phishing", desc: "Targeted phishing, spear-phishing, vishing campaigns and awareness measurement." },
            { title: "Source Code Security (SAST)", desc: "Static analysis, secret scanning, software composition analysis." },
            { title: "DAST & IAST", desc: "Dynamic and interactive application security testing in live environments." },
            { title: "Vulnerability Management", desc: "Scanning, prioritization, patching and verification cycle." },
            { title: "SOC / SIEM Services", desc: "24/7 monitoring, log collection, correlation and alert management." },
            { title: "Incident Response & Forensics", desc: "Malware analysis, digital evidence collection and reporting." },
            { title: "ISO 27001 / KVKK / GDPR Compliance", desc: "Gap analysis, policies, procedures and audit readiness." },
            { title: "Secure SDLC & DevSecOps", desc: "Security scanning integrated into CI/CD pipelines, IaC security." },
          ],
        },
        {
          key: "software", title: "Software Development",
          lead: "Web, mobile and enterprise software — modern, scalable, secure.",
          items: [
            { title: "Website Development", desc: "Corporate sites, e-commerce, headless CMS, performance-focused (Lighthouse 90+)." },
            { title: "Mobile App Development", desc: "iOS, Android and cross-platform (React Native / Flutter) applications." },
            { title: "Web Application Development", desc: "SaaS, dashboards, B2B portals, real-time applications." },
            { title: "Enterprise Software & ERP", desc: "Custom ERP, CRM and workflow integrations." },
            { title: "API & Microservices Architecture", desc: "REST, GraphQL, gRPC; event-driven architectures and service mesh." },
            { title: "Cloud & DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), observability." },
            { title: "Software Modernization", desc: "Refactoring legacy systems and migrating to the cloud." },
            { title: "Software Protection & Licensing", desc: "Anti-tamper, code obfuscation, DRM, license server solutions." },
          ],
        },
        {
          key: "qa", title: "Software Testing & QA",
          lead: "Every scenario, every load, every edge case validated before production.",
          items: [
            { title: "Manual & Exploratory Testing", desc: "Scenario-based manual testing by experienced QA engineers." },
            { title: "Test Automation", desc: "End-to-end automation with Selenium, Cypress, Playwright, Appium." },
            { title: "Performance & Load Testing", desc: "Realistic load scenarios with JMeter, k6, Locust." },
            { title: "Security Testing", desc: "Application security testing with OWASP tools, ZAP, Burp Suite." },
            { title: "API Testing", desc: "Functional and integration tests with Postman, REST Assured, Karate." },
            { title: "Mobile Device Lab Testing", desc: "iOS/Android compatibility testing on a real device pool." },
            { title: "Accessibility (a11y) Testing", desc: "WCAG 2.1 / 2.2 AA compliance check and remediation." },
            { title: "User Acceptance Testing (UAT)", desc: "UAT planning and execution with the business team." },
            { title: "Regression Testing", desc: "Smart regression strategy and release assurance." },
          ],
        },
        {
          key: "ai", title: "AI & Data",
          lead: "Generative AI, machine learning and data — build the future today.",
          items: [
            { title: "Generative AI (GenAI)", desc: "LLM-based chatbots, assistants and content generation systems." },
            { title: "RAG & Knowledge Assistants", desc: "Custom retrieval engines combining your knowledge base with LLMs." },
            { title: "Machine Learning (ML)", desc: "Forecasting, classification, anomaly detection, recommender systems." },
            { title: "Computer Vision", desc: "Object detection, OCR, quality control, face/threat recognition." },
            { title: "Natural Language Processing (NLP)", desc: "Sentiment analysis, topic modeling, translation, summarization." },
            { title: "AI Testing & Evaluation", desc: "Model accuracy, bias, security (jailbreak) testing and evaluation." },
            { title: "MLOps & Data Pipelines", desc: "Model deployment, monitoring, retraining and data management." },
            { title: "Data Engineering & Analytics", desc: "Data warehouses, ETL, real-time analytics, BI dashboards." },
          ],
        },
      ],
      cta: { title: "Let's strengthen your tech.", body: "Tell us your needs — we will plan a free discovery call for your cybersecurity, software or AI project.", button: "Get in Touch" },
    },
  },

  // ─────────────────────────────────────────────────────────── AR
  ar: {
    construction: {
      eyebrow: "الإنشاءات",
      hero: {
        title: "حلول إنشائية مؤسسية من التصميم وحتى التسليم.",
        subtitle: "نقدم خدمات التصميم والاستشارات والهندسة والتصنيع تحت سقف واحد للمشاريع السكنية والتجارية والصناعية.",
        cta: "شارك متطلبات مشروعك",
      },
      services: {
        title: "خدمات الإنشاءات لدينا",
        lead: "إدارة منضبطة في كل مرحلة وفق المعايير الدولية.",
        items: [
          { key: "design", title: "التصميم", desc: "المفهوم المعماري والتصميم الداخلي وتنسيق الحدائق والمحاكاة البصرية — توازن بين الجمال والوظيفة والاستدامة.", features: ["المفهوم المعماري والتصميم الأولي", "العمارة الداخلية وتصميم الفضاءات", "تنسيق الحدائق والتصميم الخارجي", "المحاكاة البصرية ثلاثية الأبعاد", "تصميم الإضاءة والصوتيات"] },
          { key: "consulting", title: "الاستشارات", desc: "دراسات الجدوى والتراخيص واستشارات إدارة المشاريع وإدارة العقود والمخاطر لحماية استثماراتك.", features: ["الجدوى وتحليل التكاليف", "التراخيص والاستشارات التنظيمية", "استشارات إدارة المشاريع (PMC)", "إدارة العقود والمناقصات", "إدارة المخاطر والجودة"] },
          { key: "engineering", title: "الهندسة", desc: "هندسة إنشائية وميكانيكية وكهربائية وبنية تحتية مع تنسيق متكامل قائم على BIM.", features: ["الهندسة الإنشائية والخرسانية", "الميكانيكية (HVAC والصحية)", "الكهرباء وأنظمة التيار الخفيف", "تنسيق BIM", "تقارير التحليل والحسابات الإنشائية"] },
          { key: "manufacturing", title: "التصنيع", desc: "إنشاءات معدنية وعناصر سابقة الصب وأنظمة الواجهات والأثاث المخصص؛ يشمل التركيب في الموقع.", features: ["تصنيع الإنشاءات المعدنية", "العناصر الخرسانية سابقة الصب", "أنظمة الواجهات والنجارة", "الأثاث والديكور المخصص", "التركيب والتشغيل في الموقع"] },
        ],
      },
      cta: { title: "لنتحدث عن مشروعك.", body: "شاركنا الموجز ليرد عليك فريقنا بالجدوى الفنية والعرض خلال يوم عمل واحد.", button: "تواصل معنا" },
    },
    export: {
      eyebrow: "التصدير",
      hero: {
        title: "جسر موثوق بين المنتجات التركية والمشترين الأجانب.",
        subtitle: "نقوم بأبحاث المنتجات وتأهيل الموردين وتنفيذ عمليات التصدير الكاملة نيابة عن المشترين الأجانب.",
        cta: "نموذج الطلب",
      },
      services: {
        title: "خدمات التصدير لدينا",
        lead: "توريد محترف من تركيا للمشترين الأجانب.",
        items: [
          { title: "بحث وتوريد المنتجات", desc: "نبحث عن المنتجات ذات المنشأ التركي ونرشّح أنسب المصنعين والموردين." },
          { title: "التحقق من الموردين", desc: "زيارات ميدانية وفحص المصداقية المالية والتحقق من الشهادات ومراجعة المراجع." },
          { title: "الشراء وإدارة العينات", desc: "توفير العينات والتفاوض وتحسين الأسعار وشروط الدفع وإدارة العقود." },
          { title: "مراقبة الجودة والتدقيق", desc: "فحوص الجودة قبل الإنتاج وأثناءه وقبل الشحن (مطابقة لـ ISO)." },
          { title: "عمليات التصدير", desc: "الجمارك واللوجستيات والتأمين والاعتماد المستندي والشحن الدولي — إدارة كاملة لعمليات التصدير." },
          { title: "التوثيق والامتثال", desc: "شهادة المنشأ، الفاتورة، قائمة التعبئة، ATR/EUR.1، شهادات الصحة والمطابقة." },
        ],
      },
      form: {
        title: "نموذج الطلب",
        lead: "شاركنا تفاصيل المنتجات أو الخدمات التي تحتاجها وسنُعدّ لك عرضًا مخصصًا.",
        labels: { fullName: "الاسم الكامل", email: "البريد الإلكتروني", phone: "الهاتف", company: "الشركة", country: "بلدك", productCategory: "فئة المنتج", productDetails: "تفاصيل المنتج / المواصفات", quantity: "الكمية", targetMarket: "السوق المستهدف", timeline: "الجدول الزمني", budgetRange: "نطاق الميزانية (اختياري)", notes: "ملاحظات إضافية" },
        placeholders: { productCategory: "مثال: نسيج، غذاء، آلات، أثاث، مواد بناء...", productDetails: "صف المنتج المطلوب ومستوى الجودة وتفضيلات العلامة التجارية.", quantity: "مثال: 1,000 وحدة / شهر، 20 طن، حاوية واحدة", timeline: "مثال: 4-6 أسابيع", budgetRange: "مثال: 50,000 - 100,000 USD" },
        submit: "إرسال الطلب", submitting: "جاري الإرسال...",
        successTitle: "تم استلام طلبك", successBody: "سيرد عليك فريق التصدير لدينا بعرض مفصل خلال يوم عمل واحد.",
        errorTitle: "حدث خطأ", errorBody: "يرجى المحاولة مرة أخرى.",
        confidential: "تبقى معلوماتك التجارية سرية تمامًا.",
      },
    },
    technology: {
      eyebrow: "التكنولوجيا",
      hero: {
        title: "الأمن السيبراني والبرمجيات والذكاء الاصطناعي — شريك تقني واحد.",
        subtitle: "من اختبارات الاختراق و DDoS إلى تطوير البرمجيات المؤسسية وحلول الذكاء الاصطناعي وضمان الجودة — مجموعة تقنية متكاملة.",
        cta: "تحدث إلينا",
      },
      categories: [
        {
          key: "cyber", title: "الأمن السيبراني واختبارات الاختراق",
          lead: "نختبر بنيتك التحتية بعقلية المهاجم ونعزّز دفاعاتك.",
          items: [
            { title: "اختبار اختراق ويب", desc: "OWASP Top 10 وما بعدها: SQLi و XSS و RCE و IDOR و SSRF وثغرات المصادقة." },
            { title: "اختبار اختراق الجوال", desc: "هندسة عكسية لـ iOS/Android، كشف Jailbreak/Root، أمن التخزين." },
            { title: "اختبار اختراق الشبكة", desc: "اختبار شبكة داخلي وخارجي، اختبار التجزئة، تحليل ثغرات Active Directory." },
            { title: "اختبار اختراق API", desc: "تحليل الصلاحيات وتحديد المعدل وتسريب البيانات في REST/GraphQL." },
            { title: "اختبار DDoS والصمود", desc: "سيناريوهات DDoS حجمية وبروتوكولية وعلى مستوى التطبيق." },
            { title: "أمن السحابة (AWS/Azure/GCP)", desc: "تدقيق IAM وS3/Blob/GCS و KMS وامتثال CIS." },
            { title: "Red Team ومحاكاة الخصم", desc: "محاكاة الهجمات وفق إطار MITRE ATT&CK واختبارات TTP." },
            { title: "الهندسة الاجتماعية والتصيد", desc: "حملات تصيد موجهة وقياس الوعي." },
            { title: "تحليل أمان الكود (SAST)", desc: "تحليل ثابت ومسح الأسرار وتحليل التبعيات (SCA)." },
            { title: "DAST و IAST", desc: "اختبارات أمان ديناميكية وتفاعلية في بيئات حية." },
            { title: "إدارة الثغرات", desc: "المسح والترتيب وتطبيق التصحيحات والتحقق." },
            { title: "خدمات SOC / SIEM", desc: "مراقبة 24/7 وجمع السجلات والربط وإدارة التنبيهات." },
            { title: "الاستجابة للحوادث والأدلة الجنائية", desc: "تحليل البرمجيات الخبيثة وجمع الأدلة الرقمية والتقارير." },
            { title: "الامتثال ISO 27001 / KVKK / GDPR", desc: "تحليل الفجوات، السياسات، الإجراءات وجاهزية التدقيق." },
            { title: "SDLC الآمن و DevSecOps", desc: "دمج فحوص الأمان في CI/CD وأمن IaC." },
          ],
        },
        {
          key: "software", title: "تطوير البرمجيات",
          lead: "حلول ويب وموبايل ومؤسسية — حديثة وقابلة للتوسع وآمنة.",
          items: [
            { title: "تطوير المواقع", desc: "مواقع مؤسسية وتجارة إلكترونية وheadless CMS بأداء عالٍ (Lighthouse 90+)." },
            { title: "تطوير تطبيقات الجوال", desc: "تطبيقات iOS وAndroid وعابرة المنصات (React Native / Flutter)." },
            { title: "تطوير تطبيقات الويب", desc: "SaaS ولوحات تحكم وبوابات B2B وتطبيقات في الوقت الفعلي." },
            { title: "البرمجيات المؤسسية و ERP", desc: "ERP وCRM مخصصان وتكاملات سير العمل." },
            { title: "API ومعمارية الخدمات المصغرة", desc: "REST و GraphQL و gRPC ومعماريات Event-Driven." },
            { title: "السحابة و DevOps", desc: "Kubernetes و Docker و CI/CD و IaC (Terraform) والمراقبة." },
            { title: "تحديث البرمجيات", desc: "إعادة هيكلة الأنظمة القديمة والترحيل إلى السحابة." },
            { title: "حماية البرمجيات والترخيص", desc: "Anti-tamper وObfuscation و DRM وحلول خوادم التراخيص." },
          ],
        },
        {
          key: "qa", title: "اختبارات البرمجيات وضمان الجودة",
          lead: "كل سيناريو وكل حِمل وكل حالة طرفية تحت السيطرة قبل الإنتاج.",
          items: [
            { title: "اختبار يدوي واستكشافي", desc: "اختبارات يدوية قائمة على السيناريوهات بواسطة مهندسي QA." },
            { title: "أتمتة الاختبار", desc: "أتمتة شاملة باستخدام Selenium و Cypress و Playwright و Appium." },
            { title: "اختبار الأداء والتحميل", desc: "سيناريوهات تحميل واقعية باستخدام JMeter و k6 و Locust." },
            { title: "اختبار الأمان", desc: "اختبارات أمان تطبيقات بأدوات OWASP و ZAP و Burp Suite." },
            { title: "اختبار API", desc: "اختبارات وظيفية وتكامل باستخدام Postman و REST Assured و Karate." },
            { title: "اختبارات مختبر الأجهزة", desc: "اختبارات توافق iOS/Android على مجموعة أجهزة حقيقية." },
            { title: "اختبار إمكانية الوصول (a11y)", desc: "فحص الامتثال لـ WCAG 2.1 / 2.2 AA وتوصيات المعالجة." },
            { title: "اختبار قبول المستخدم (UAT)", desc: "تخطيط وتنفيذ UAT بالتعاون مع فريق العمل." },
            { title: "اختبار الانحدار", desc: "استراتيجية انحدار ذكية وضمان الإصدارات." },
          ],
        },
        {
          key: "ai", title: "الذكاء الاصطناعي والبيانات",
          lead: "الذكاء الاصطناعي التوليدي وتعلم الآلة وحلول البيانات — ابنِ المستقبل اليوم.",
          items: [
            { title: "الذكاء الاصطناعي التوليدي (GenAI)", desc: "روبوتات محادثة ومساعدون وأنظمة توليد محتوى تعتمد على LLM." },
            { title: "RAG ومساعدو قاعدة المعرفة", desc: "محركات بحث مخصصة تجمع قاعدة معرفتك مع LLM." },
            { title: "تعلم الآلة (ML)", desc: "التنبؤ والتصنيف وكشف الشذوذ وأنظمة التوصية." },
            { title: "الرؤية الحاسوبية", desc: "كشف الكائنات و OCR ومراقبة الجودة والتعرف على الوجه/التهديدات." },
            { title: "معالجة اللغة الطبيعية (NLP)", desc: "تحليل المشاعر ونمذجة المواضيع والترجمة والتلخيص." },
            { title: "اختبار وتقييم الذكاء الاصطناعي", desc: "اختبارات دقة النموذج والانحياز والأمن (Jailbreak) والتقييم." },
            { title: "MLOps وخطوط البيانات", desc: "نشر النموذج ومراقبته وإعادة تدريبه وإدارة البيانات." },
            { title: "هندسة البيانات والتحليلات", desc: "مستودعات البيانات و ETL والتحليلات الفورية ولوحات BI." },
          ],
        },
      ],
      cta: { title: "لنعزّز تقنياتك.", body: "أخبرنا باحتياجاتك — سنخطط لمكالمة استكشاف مجانية لمشروع الأمن السيبراني أو البرمجيات أو الذكاء الاصطناعي.", button: "تواصل معنا" },
    },
  },

  // ─────────────────────────────────────────────────────────── ES
  es: {
    construction: {
      eyebrow: "CONSTRUCCIÓN",
      hero: {
        title: "Soluciones de construcción corporativa, del diseño a la entrega.",
        subtitle: "Diseño, consultoría, ingeniería y fabricación bajo un mismo techo para proyectos residenciales, comerciales e industriales.",
        cta: "Comparta su Brief",
      },
      services: {
        title: "Nuestros Servicios de Construcción",
        lead: "Gestión disciplinada en cada etapa con estándares internacionales.",
        items: [
          { key: "design", title: "Diseño", desc: "Concepto arquitectónico, diseño interior, paisajismo y visualización — equilibrio entre estética, función y sostenibilidad.", features: ["Concepto arquitectónico y anteproyecto", "Arquitectura interior", "Paisajismo y diseño exterior", "Visualización y render 3D", "Diseño lumínico y acústico"] },
          { key: "consulting", title: "Consultoría", desc: "Viabilidad, permisos, consultoría de gestión de proyectos, gestión contractual y de riesgos para proteger su inversión.", features: ["Viabilidad y análisis de costos", "Permisos y asesoría regulatoria", "Consultoría de gestión de proyectos (PMC)", "Gestión de contratos y licitaciones", "Supervisión de riesgos y calidad"] },
          { key: "engineering", title: "Ingeniería", desc: "Ingeniería estructural, mecánica, eléctrica e infraestructura con coordinación integrada basada en BIM.", features: ["Ingeniería estructural y hormigón", "Mecánica (HVAC, fontanería)", "Eléctrica y corrientes débiles", "Coordinación BIM", "Análisis y memorias de cálculo"] },
          { key: "manufacturing", title: "Fabricación", desc: "Estructuras metálicas, prefabricados, fachadas y carpintería a medida; instalación en obra incluida.", features: ["Fabricación de estructuras metálicas", "Elementos prefabricados de hormigón", "Fachadas y carpintería", "Mobiliario y decoración a medida", "Instalación y puesta en marcha"] },
        ],
      },
      cta: { title: "Hablemos de su proyecto.", body: "Comparta su brief y nuestro equipo responderá con la viabilidad técnica y una propuesta en 1 día hábil.", button: "Contáctenos" },
    },
    export: {
      eyebrow: "EXPORTACIÓN",
      hero: {
        title: "Un puente confiable entre los productos turcos y los compradores globales.",
        subtitle: "Investigamos, calificamos y adquirimos productos turcos en nombre de compradores extranjeros, gestionando operaciones de exportación de extremo a extremo.",
        cta: "Formulario de Solicitud",
      },
      services: {
        title: "Nuestros Servicios de Exportación",
        lead: "Sourcing profesional desde Türkiye para compradores extranjeros.",
        items: [
          { title: "Investigación y Sourcing de Productos", desc: "Investigamos productos de origen turco y preseleccionamos los fabricantes y proveedores más adecuados." },
          { title: "Verificación de Proveedores", desc: "Visitas in situ, verificación de solidez financiera, certificaciones y revisión de referencias." },
          { title: "Compras y Muestras", desc: "Obtención de muestras, negociación, optimización de precios, condiciones de pago y contratos." },
          { title: "Control de Calidad y Auditoría", desc: "QC pre-producción, en producción y pre-embarque (auditorías alineadas con ISO)." },
          { title: "Operaciones de Exportación", desc: "Aduanas, logística, seguros, carta de crédito y transporte internacional — gestión integral." },
          { title: "Documentación y Cumplimiento", desc: "Certificado de origen, factura, packing list, ATR/EUR.1, certificados sanitarios y de conformidad." },
        ],
      },
      form: {
        title: "Formulario de Solicitud",
        lead: "Comparta los detalles de los productos o servicios que necesita y prepararemos una propuesta a medida.",
        labels: { fullName: "Nombre completo", email: "Email", phone: "Teléfono", company: "Empresa", country: "Su país", productCategory: "Categoría de producto", productDetails: "Detalles / especificación", quantity: "Cantidad", targetMarket: "Mercado objetivo", timeline: "Plazo", budgetRange: "Rango de presupuesto (opcional)", notes: "Notas adicionales" },
        placeholders: { productCategory: "Ej. Textil, alimentos, maquinaria, mobiliario, materiales de construcción...", productDetails: "Describa el producto, nivel de calidad y preferencias de marca.", quantity: "Ej. 1.000 unidades/mes, 20 toneladas, 1 contenedor", timeline: "Ej. 4-6 semanas", budgetRange: "Ej. 50.000 - 100.000 USD" },
        submit: "Enviar solicitud", submitting: "Enviando...",
        successTitle: "Solicitud recibida", successBody: "Nuestro equipo de exportación responderá con una propuesta detallada en 1 día hábil.",
        errorTitle: "Algo salió mal", errorBody: "Por favor, inténtelo de nuevo.",
        confidential: "Su información comercial se mantiene estrictamente confidencial.",
      },
    },
    technology: {
      eyebrow: "TECNOLOGÍA",
      hero: {
        title: "Ciberseguridad, software e IA — un único partner tecnológico.",
        subtitle: "Desde pruebas de penetración y DDoS hasta software empresarial, IA y aseguramiento de calidad — un stack tecnológico completo.",
        cta: "Hablemos",
      },
      categories: [
        {
          key: "cyber", title: "Ciberseguridad y Pentesting",
          lead: "Probamos su infraestructura con mentalidad de atacante y reforzamos sus defensas.",
          items: [
            { title: "Pentest Web", desc: "OWASP Top 10 y más allá: SQLi, XSS, RCE, IDOR, SSRF, autenticación." },
            { title: "Pentest Móvil", desc: "iOS / Android: ingeniería inversa, detección de jailbreak/root, seguridad de almacenamiento." },
            { title: "Pentest de Red", desc: "Pentest interno y externo, segmentación, análisis de Active Directory." },
            { title: "Pentest de API", desc: "Autorización, rate limiting y fuga de datos en REST/GraphQL." },
            { title: "Pruebas DDoS y Resiliencia", desc: "Escenarios DDoS volumétricos, de protocolo y aplicación." },
            { title: "Seguridad Cloud (AWS/Azure/GCP)", desc: "Auditoría IAM, S3/Blob/GCS, KMS y benchmark CIS." },
            { title: "Red Team y Simulación", desc: "Simulación basada en MITRE ATT&CK y pruebas TTP." },
            { title: "Ingeniería Social y Phishing", desc: "Phishing dirigido, spear-phishing, vishing y medición de concienciación." },
            { title: "SAST", desc: "Análisis estático, secret scanning, análisis de composición (SCA)." },
            { title: "DAST e IAST", desc: "Pruebas dinámicas e interactivas en entornos en producción." },
            { title: "Gestión de Vulnerabilidades", desc: "Escaneo, priorización, parcheo y verificación." },
            { title: "Servicios SOC / SIEM", desc: "Monitorización 24/7, recolección de logs, correlación y alertas." },
            { title: "Respuesta a Incidentes y Forense", desc: "Análisis de malware, recolección de evidencia digital y reporte." },
            { title: "Cumplimiento ISO 27001 / KVKK / GDPR", desc: "Análisis de brechas, políticas, procedimientos y preparación de auditoría." },
            { title: "SDLC Seguro y DevSecOps", desc: "Integración de seguridad en CI/CD y seguridad IaC." },
          ],
        },
        {
          key: "software", title: "Desarrollo de Software",
          lead: "Software web, móvil y empresarial — moderno, escalable y seguro.",
          items: [
            { title: "Desarrollo Web", desc: "Sitios corporativos, e-commerce, headless CMS, alto rendimiento (Lighthouse 90+)." },
            { title: "Apps Móviles", desc: "Aplicaciones iOS, Android y multiplataforma (React Native / Flutter)." },
            { title: "Aplicaciones Web", desc: "SaaS, dashboards, portales B2B, aplicaciones en tiempo real." },
            { title: "Software Empresarial y ERP", desc: "ERP y CRM personalizados e integraciones de workflow." },
            { title: "API y Microservicios", desc: "REST, GraphQL, gRPC; arquitecturas event-driven y service mesh." },
            { title: "Cloud y DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), observabilidad." },
            { title: "Modernización", desc: "Refactorización de legacy y migración a la nube." },
            { title: "Protección y Licenciamiento", desc: "Anti-tamper, ofuscación, DRM y servidores de licencias." },
          ],
        },
        {
          key: "qa", title: "Testing y QA",
          lead: "Cada escenario, cada carga y cada caso límite validado antes de producción.",
          items: [
            { title: "Pruebas Manuales y Exploratorias", desc: "Pruebas manuales basadas en escenarios por ingenieros QA." },
            { title: "Automatización", desc: "Automatización end-to-end con Selenium, Cypress, Playwright, Appium." },
            { title: "Performance y Carga", desc: "Escenarios realistas con JMeter, k6, Locust." },
            { title: "Pruebas de Seguridad", desc: "Pruebas con OWASP, ZAP, Burp Suite." },
            { title: "Pruebas de API", desc: "Funcionales e integración con Postman, REST Assured, Karate." },
            { title: "Lab de Dispositivos Móviles", desc: "Pruebas de compatibilidad iOS/Android en dispositivos reales." },
            { title: "Accesibilidad (a11y)", desc: "Cumplimiento WCAG 2.1 / 2.2 AA y plan de remediación." },
            { title: "UAT", desc: "Planificación y ejecución de UAT con el equipo de negocio." },
            { title: "Regresión", desc: "Estrategia inteligente de regresión y aseguramiento de releases." },
          ],
        },
        {
          key: "ai", title: "IA y Datos",
          lead: "IA generativa, machine learning y datos — construya el futuro hoy.",
          items: [
            { title: "IA Generativa (GenAI)", desc: "Chatbots, asistentes y sistemas de generación de contenido basados en LLM." },
            { title: "RAG y Asistentes de Conocimiento", desc: "Motores de búsqueda personalizados que combinan su base de conocimientos con LLMs." },
            { title: "Machine Learning (ML)", desc: "Forecasting, clasificación, detección de anomalías y recomendadores." },
            { title: "Visión por Computador", desc: "Detección de objetos, OCR, control de calidad, reconocimiento facial." },
            { title: "NLP", desc: "Análisis de sentimiento, modelado de tópicos, traducción, resumen." },
            { title: "Testing y Evaluación de IA", desc: "Precisión, sesgo, seguridad (jailbreak) y evaluación." },
            { title: "MLOps y Pipelines", desc: "Despliegue, monitoreo, reentrenamiento y gestión de datos." },
            { title: "Ingeniería de Datos y Analítica", desc: "Data warehouses, ETL, analítica en tiempo real, dashboards BI." },
          ],
        },
      ],
      cta: { title: "Reforcemos su tecnología.", body: "Cuéntenos sus necesidades — agendaremos una llamada de descubrimiento gratuita para su proyecto.", button: "Contáctenos" },
    },
  },

  // ─────────────────────────────────────────────────────────── RU
  ru: {
    construction: {
      eyebrow: "СТРОИТЕЛЬСТВО",
      hero: {
        title: "Корпоративные строительные решения — от проектирования до сдачи.",
        subtitle: "Дизайн, консалтинг, проектирование и производство под одной крышей для жилых, коммерческих и промышленных проектов.",
        cta: "Поделитесь брифом",
      },
      services: {
        title: "Наши строительные услуги",
        lead: "Дисциплинированное управление на каждом этапе по международным стандартам.",
        items: [
          { key: "design", title: "Дизайн", desc: "Архитектурная концепция, интерьер, ландшафт и визуализация — баланс эстетики, функциональности и устойчивости.", features: ["Архитектурная концепция и эскиз", "Интерьерная архитектура", "Ландшафт и экстерьер", "3D-визуализация и рендер", "Освещение и акустика"] },
          { key: "consulting", title: "Консалтинг", desc: "ТЭО, разрешения, управление проектами, контракты и управление рисками для защиты инвестиций.", features: ["ТЭО и анализ затрат", "Разрешения и регуляторика", "Управление проектами (PMC)", "Контракты и тендеры", "Управление рисками и качеством"] },
          { key: "engineering", title: "Проектирование", desc: "Конструктив, механика, электрика и инфраструктура с интегрированной координацией на BIM.", features: ["Конструкции и ЖБ", "МЭП (HVAC, сантехника)", "Электрика и слаботочные сети", "BIM-координация", "Расчётные отчёты"] },
          { key: "manufacturing", title: "Производство", desc: "Металлоконструкции, сборные элементы, фасады и индивидуальная мебель; монтаж и сдача включены.", features: ["Производство металлоконструкций", "Сборные ЖБ-элементы", "Фасады и столярные системы", "Индивидуальная мебель", "Монтаж и пуско-наладка"] },
        ],
      },
      cta: { title: "Обсудим ваш проект.", body: "Поделитесь брифом — мы вернёмся с тех. ТЭО и предложением в течение 1 рабочего дня.", button: "Связаться" },
    },
    export: {
      eyebrow: "ЭКСПОРТ",
      hero: {
        title: "Надёжный мост между турецкими товарами и зарубежными покупателями.",
        subtitle: "Мы ищем, проверяем и закупаем товары турецкого происхождения от имени иностранных покупателей — полный экспортный цикл.",
        cta: "Форма заявки",
      },
      services: {
        title: "Наши экспортные услуги",
        lead: "Профессиональный сорсинг из Турции для иностранных покупателей.",
        items: [
          { title: "Поиск и сорсинг продукции", desc: "Исследуем продукцию турецкого происхождения и подбираем подходящих производителей и поставщиков." },
          { title: "Проверка поставщиков", desc: "Выезды на производство, проверка финансовой надёжности, сертификатов и рекомендаций." },
          { title: "Закупки и образцы", desc: "Получение образцов, переговоры, оптимизация цен, условия оплаты и контракты." },
          { title: "Контроль качества и аудит", desc: "Контроль до, во время и перед отгрузкой (по стандартам ISO)." },
          { title: "Экспортные операции", desc: "Таможня, логистика, страхование, аккредитив и международные перевозки — полный процесс." },
          { title: "Документация и комплаенс", desc: "Сертификат происхождения, инвойс, упаковочный лист, ATR/EUR.1, сертификаты здоровья и соответствия." },
        ],
      },
      form: {
        title: "Форма заявки",
        lead: "Опишите нужные товары/услуги — мы подготовим персональное предложение.",
        labels: { fullName: "Имя и фамилия", email: "Email", phone: "Телефон", company: "Компания", country: "Страна", productCategory: "Категория продукции", productDetails: "Описание / спецификация", quantity: "Количество", targetMarket: "Целевой рынок", timeline: "Сроки", budgetRange: "Бюджет (опционально)", notes: "Дополнительно" },
        placeholders: { productCategory: "Напр.: текстиль, продукты, оборудование, мебель, стройматериалы...", productDetails: "Опишите продукт, уровень качества, предпочтения по бренду.", quantity: "Напр.: 1 000 шт./мес, 20 тонн, 1 контейнер", timeline: "Напр.: 4-6 недель", budgetRange: "Напр.: 50 000 - 100 000 USD" },
        submit: "Отправить заявку", submitting: "Отправка...",
        successTitle: "Заявка получена", successBody: "Наша команда экспортного отдела ответит с подробным предложением в течение 1 рабочего дня.",
        errorTitle: "Произошла ошибка", errorBody: "Пожалуйста, попробуйте ещё раз.",
        confidential: "Ваша коммерческая информация остаётся строго конфиденциальной.",
      },
    },
    technology: {
      eyebrow: "ТЕХНОЛОГИИ",
      hero: {
        title: "Кибербезопасность, ПО и ИИ — единый технологический партнёр.",
        subtitle: "От пентестов и DDoS-тестов до корпоративного ПО, ИИ-решений и QA — полный технологический стек.",
        cta: "Связаться",
      },
      categories: [
        {
          key: "cyber", title: "Кибербезопасность и пентесты",
          lead: "Тестируем инфраструктуру с позиции атакующего и усиливаем защиту.",
          items: [
            { title: "Web-пентест", desc: "OWASP Top 10 и не только: SQLi, XSS, RCE, IDOR, SSRF, аутентификация." },
            { title: "Mobile-пентест", desc: "iOS / Android: реверс-инжиниринг, jailbreak/root, безопасность хранилища." },
            { title: "Network-пентест", desc: "Внутренний и внешний пентест, сегментация, AD-анализ." },
            { title: "API-пентест", desc: "Авторизация, rate limiting, утечки данных в REST/GraphQL." },
            { title: "DDoS-тест и устойчивость", desc: "Объёмные, протокольные и прикладные DDoS-сценарии." },
            { title: "Облачная безопасность", desc: "Аудит IAM, S3/Blob/GCS, KMS, соответствие CIS (AWS/Azure/GCP)." },
            { title: "Red Team", desc: "Симуляция атак по MITRE ATT&CK и TTP-тесты." },
            { title: "Социнженерия и фишинг", desc: "Целевые phishing/spear-phishing/vishing и оценка осведомлённости." },
            { title: "SAST", desc: "Статический анализ, поиск секретов, SCA." },
            { title: "DAST и IAST", desc: "Динамическое и интерактивное тестирование в продуктивной среде." },
            { title: "Управление уязвимостями", desc: "Сканирование, приоритизация, патчи и верификация." },
            { title: "SOC / SIEM", desc: "Мониторинг 24/7, сбор логов, корреляция, оповещения." },
            { title: "Реагирование и форензика", desc: "Анализ malware, цифровые доказательства и отчёты." },
            { title: "ISO 27001 / KVKK / GDPR", desc: "GAP-анализ, политики, процедуры и подготовка к аудиту." },
            { title: "Secure SDLC и DevSecOps", desc: "Интеграция безопасности в CI/CD и IaC." },
          ],
        },
        {
          key: "software", title: "Разработка ПО",
          lead: "Web, mobile и корпоративное ПО — современное, масштабируемое, безопасное.",
          items: [
            { title: "Веб-разработка", desc: "Корпоративные сайты, e-commerce, headless CMS (Lighthouse 90+)." },
            { title: "Мобильные приложения", desc: "iOS, Android и кросс-платформенные (React Native / Flutter)." },
            { title: "Веб-приложения", desc: "SaaS, дашборды, B2B-порталы, реалтайм-приложения." },
            { title: "Корпоративное ПО и ERP", desc: "Кастомные ERP, CRM и интеграции workflow." },
            { title: "API и микросервисы", desc: "REST, GraphQL, gRPC; event-driven и service mesh." },
            { title: "Cloud и DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), наблюдаемость." },
            { title: "Модернизация ПО", desc: "Рефакторинг legacy и миграция в облако." },
            { title: "Защита и лицензирование", desc: "Anti-tamper, обфускация, DRM, лицензионные серверы." },
          ],
        },
        {
          key: "qa", title: "Тестирование и QA",
          lead: "Каждый сценарий, каждая нагрузка и каждый граничный случай под контролем до релиза.",
          items: [
            { title: "Ручное и исследовательское", desc: "Сценарное ручное тестирование опытными QA." },
            { title: "Автоматизация", desc: "End-to-end на Selenium, Cypress, Playwright, Appium." },
            { title: "Производительность и нагрузка", desc: "Реальные сценарии на JMeter, k6, Locust." },
            { title: "Безопасность", desc: "OWASP, ZAP, Burp Suite." },
            { title: "API-тестирование", desc: "Функциональные и интеграционные тесты Postman, REST Assured, Karate." },
            { title: "Mobile Lab", desc: "Совместимость iOS/Android на пуле реальных устройств." },
            { title: "Доступность (a11y)", desc: "WCAG 2.1 / 2.2 AA и план устранения." },
            { title: "UAT", desc: "Планирование и проведение UAT с бизнес-командой." },
            { title: "Регресс", desc: "Умная стратегия регресса и гарантия релизов." },
          ],
        },
        {
          key: "ai", title: "ИИ и данные",
          lead: "Generative AI, ML и данные — стройте будущее уже сегодня.",
          items: [
            { title: "Generative AI", desc: "Чат-боты, ассистенты и системы генерации контента на LLM." },
            { title: "RAG-ассистенты", desc: "Поисковые движки, объединяющие вашу базу знаний и LLM." },
            { title: "Machine Learning", desc: "Прогноз, классификация, аномалии, рекомендации." },
            { title: "Computer Vision", desc: "Детекция объектов, OCR, контроль качества, распознавание лиц/угроз." },
            { title: "NLP", desc: "Анализ тональности, тематическое моделирование, перевод, суммаризация." },
            { title: "Тестирование ИИ", desc: "Точность, bias, безопасность (jailbreak) и оценка." },
            { title: "MLOps и Data Pipelines", desc: "Деплой, мониторинг, переобучение и управление данными." },
            { title: "Data Engineering", desc: "DWH, ETL, аналитика реального времени, BI-дашборды." },
          ],
        },
      ],
      cta: { title: "Усилим ваши технологии.", body: "Расскажите о задачах — мы проведём бесплатный discovery-звонок по кибербезопасности, ПО или ИИ.", button: "Связаться" },
    },
  },

  // ─────────────────────────────────────────────────────────── DE
  de: {
    construction: {
      eyebrow: "BAU",
      hero: {
        title: "Bau­lösungen für Unternehmen — vom Entwurf bis zur Übergabe.",
        subtitle: "Design, Beratung, Engineering und Fertigung unter einem Dach für Wohn-, Gewerbe- und Industrieprojekte.",
        cta: "Briefing teilen",
      },
      services: {
        title: "Unsere Bauleistungen",
        lead: "Disziplinierte Steuerung in jeder Phase nach internationalen Standards.",
        items: [
          { key: "design", title: "Design", desc: "Architektonisches Konzept, Innenarchitektur, Landschaftsgestaltung und Visualisierung — Ästhetik, Funktion und Nachhaltigkeit im Gleichgewicht.", features: ["Architekturkonzept & Vorentwurf", "Innenarchitektur", "Landschaft & Außengestaltung", "3D-Visualisierung & Render", "Beleuchtung & Akustik"] },
          { key: "consulting", title: "Beratung", desc: "Machbarkeit, Genehmigungen, Projektmanagement-Beratung sowie Vertrags- und Risikomanagement zum Schutz Ihrer Investition.", features: ["Machbarkeit & Kostenanalyse", "Genehmigungen & Regulierung", "Projektmanagement (PMC)", "Vertrags- & Ausschreibungsmanagement", "Risiko- & Qualitätsaufsicht"] },
          { key: "engineering", title: "Engineering", desc: "Tragwerk, Mechanik, Elektrik und Infrastruktur mit BIM-basierter Koordination.", features: ["Tragwerksplanung", "MEP (HVAC, Sanitär)", "Elektro & Schwachstrom", "BIM-Koordination", "Statische Analysen & Berechnungsberichte"] },
          { key: "manufacturing", title: "Fertigung", desc: "Stahlbau, Fertigteile, Fassadensysteme und Sondermöbel; Montage vor Ort und Übergabe inklusive.", features: ["Stahlbau-Fertigung", "Fertigteile aus Beton", "Fassaden- und Tischlersysteme", "Sondermöbel & Dekoration", "Vor-Ort-Montage & Inbetriebnahme"] },
        ],
      },
      cta: { title: "Sprechen wir über Ihr Projekt.", body: "Teilen Sie Ihr Briefing — unser Team meldet sich innerhalb eines Werktags mit Machbarkeit und Angebot.", button: "Kontakt aufnehmen" },
    },
    export: {
      eyebrow: "EXPORT",
      hero: {
        title: "Eine vertrauenswürdige Brücke zwischen türkischen Produkten und globalen Käufern.",
        subtitle: "Wir recherchieren, qualifizieren und beschaffen türkische Produkte im Auftrag ausländischer Käufer — End-to-End-Exportabwicklung.",
        cta: "Anfrageformular",
      },
      services: {
        title: "Unsere Exportleistungen",
        lead: "Professionelles Sourcing aus der Türkei für ausländische Käufer.",
        items: [
          { title: "Produktrecherche & Sourcing", desc: "Wir recherchieren türkische Produkte und identifizieren die besten Hersteller und Lieferanten." },
          { title: "Lieferantenprüfung", desc: "Vor-Ort-Besuche, Bonitätsprüfung, Zertifikatsprüfung und Referenzen." },
          { title: "Beschaffung & Muster", desc: "Musterbeschaffung, Verhandlung, Preisoptimierung, Zahlungsbedingungen und Verträge." },
          { title: "Qualitätskontrolle & Audit", desc: "QC vor, während und vor der Verschiffung (ISO-konform)." },
          { title: "Exportabwicklung", desc: "Zoll, Logistik, Versicherung, Akkreditiv und internationaler Transport — alles aus einer Hand." },
          { title: "Dokumentation & Compliance", desc: "Ursprungszeugnis, Rechnung, Packliste, ATR/EUR.1, Gesundheits- und Konformitätszertifikate." },
        ],
      },
      form: {
        title: "Anfrageformular",
        lead: "Teilen Sie uns Details zu den benötigten Produkten oder Leistungen mit — wir erstellen ein maßgeschneidertes Angebot.",
        labels: { fullName: "Vollständiger Name", email: "E-Mail", phone: "Telefon", company: "Unternehmen", country: "Ihr Land", productCategory: "Produktkategorie", productDetails: "Details / Spezifikation", quantity: "Menge", targetMarket: "Zielmarkt", timeline: "Zeitrahmen", budgetRange: "Budget (optional)", notes: "Zusätzliche Hinweise" },
        placeholders: { productCategory: "z. B. Textil, Lebensmittel, Maschinen, Möbel, Baustoffe...", productDetails: "Beschreiben Sie Produkt, Qualität und Markenpräferenzen.", quantity: "z. B. 1.000 Einheiten/Monat, 20 Tonnen, 1 Container", timeline: "z. B. 4–6 Wochen", budgetRange: "z. B. 50.000 – 100.000 USD" },
        submit: "Anfrage senden", submitting: "Wird gesendet...",
        successTitle: "Anfrage erhalten", successBody: "Unser Exportteam meldet sich innerhalb eines Werktags mit einem detaillierten Angebot.",
        errorTitle: "Etwas ist schiefgelaufen", errorBody: "Bitte versuchen Sie es erneut.",
        confidential: "Ihre Geschäftsinformationen werden streng vertraulich behandelt.",
      },
    },
    technology: {
      eyebrow: "TECHNOLOGIE",
      hero: {
        title: "Cybersicherheit, Software und KI — ein Technologiepartner.",
        subtitle: "Von Penetrations- und DDoS-Tests über Unternehmenssoftware und KI-Lösungen bis hin zu QA — ein vollständiger Tech-Stack.",
        cta: "Sprechen Sie mit uns",
      },
      categories: [
        {
          key: "cyber", title: "Cybersicherheit & Penetrationstests",
          lead: "Wir prüfen Ihre Infrastruktur mit Angreifer-Mindset und stärken Ihre Verteidigung.",
          items: [
            { title: "Web-Pentest", desc: "OWASP Top 10 und mehr: SQLi, XSS, RCE, IDOR, SSRF, Authentifizierung." },
            { title: "Mobile-Pentest", desc: "iOS / Android: Reverse Engineering, Jailbreak/Root-Erkennung, Speicher­sicherheit." },
            { title: "Netzwerk-Pentest", desc: "Internes & externes Pentesting, Segmentierung, AD-Analyse." },
            { title: "API-Pentest", desc: "Autorisierung, Rate Limiting, Datenleck-Analysen für REST/GraphQL." },
            { title: "DDoS-Tests & Resilienz", desc: "Volumetrische, Protokoll- und Application-Layer-DDoS-Szenarien." },
            { title: "Cloud-Sicherheit (AWS/Azure/GCP)", desc: "IAM, S3/Blob/GCS-Audits, KMS, CIS-Benchmarks." },
            { title: "Red Team & Adversary Simulation", desc: "Simulation nach MITRE ATT&CK und TTP-Tests." },
            { title: "Social Engineering & Phishing", desc: "Gezielte Phishing-, Spear-Phishing-, Vishing-Kampagnen." },
            { title: "Quellcode-Sicherheit (SAST)", desc: "Statische Analyse, Secret Scanning, SCA." },
            { title: "DAST & IAST", desc: "Dynamische und interaktive Tests in Live-Umgebungen." },
            { title: "Vulnerability Management", desc: "Scannen, Priorisieren, Patchen und Verifizieren." },
            { title: "SOC / SIEM", desc: "24/7-Monitoring, Log-Sammlung, Korrelation und Alarmierung." },
            { title: "Incident Response & Forensik", desc: "Malware-Analyse, digitale Beweissicherung und Reporting." },
            { title: "ISO 27001 / KVKK / GDPR", desc: "Gap-Analyse, Richtlinien, Verfahren und Audit-Vorbereitung." },
            { title: "Secure SDLC & DevSecOps", desc: "Sicherheits-Scans in CI/CD und IaC-Sicherheit." },
          ],
        },
        {
          key: "software", title: "Softwareentwicklung",
          lead: "Web, Mobile und Enterprise — modern, skalierbar, sicher.",
          items: [
            { title: "Webentwicklung", desc: "Unternehmensseiten, E-Commerce, Headless CMS (Lighthouse 90+)." },
            { title: "Mobile Apps", desc: "iOS, Android und Cross-Platform (React Native / Flutter)." },
            { title: "Webanwendungen", desc: "SaaS, Dashboards, B2B-Portale, Echtzeitanwendungen." },
            { title: "Enterprise-Software & ERP", desc: "Custom-ERP, -CRM und Workflow-Integrationen." },
            { title: "API & Microservices", desc: "REST, GraphQL, gRPC; Event-Driven & Service Mesh." },
            { title: "Cloud & DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), Observability." },
            { title: "Modernisierung", desc: "Refactoring von Legacy-Systemen und Cloud-Migration." },
            { title: "Schutz & Lizenzierung", desc: "Anti-Tamper, Obfuscation, DRM, Lizenzserver-Lösungen." },
          ],
        },
        {
          key: "qa", title: "Software-Tests & QA",
          lead: "Jedes Szenario, jede Last und jeder Edge-Case vor der Produktion validiert.",
          items: [
            { title: "Manuelle & Explorative Tests", desc: "Szenariobasierte manuelle Tests durch erfahrene QA-Ingenieure." },
            { title: "Testautomatisierung", desc: "End-to-End mit Selenium, Cypress, Playwright, Appium." },
            { title: "Performance & Last", desc: "Realistische Lastszenarien mit JMeter, k6, Locust." },
            { title: "Security-Tests", desc: "OWASP, ZAP, Burp Suite." },
            { title: "API-Tests", desc: "Funktional und Integration mit Postman, REST Assured, Karate." },
            { title: "Mobile Device Lab", desc: "iOS/Android-Kompatibilität auf echtem Gerätepool." },
            { title: "Barrierefreiheit (a11y)", desc: "WCAG 2.1 / 2.2 AA und Maßnahmenplan." },
            { title: "UAT", desc: "Planung und Durchführung mit dem Fachbereich." },
            { title: "Regression", desc: "Smarte Regressionsstrategie und Release-Sicherung." },
          ],
        },
        {
          key: "ai", title: "KI & Daten",
          lead: "Generative KI, Machine Learning und Daten — bauen Sie die Zukunft heute.",
          items: [
            { title: "Generative KI (GenAI)", desc: "LLM-basierte Chatbots, Assistenten und Content-Generatoren." },
            { title: "RAG & Knowledge Assistants", desc: "Eigene Retrieval-Engines, die Ihre Wissensbasis mit LLMs kombinieren." },
            { title: "Machine Learning", desc: "Forecasting, Klassifikation, Anomalie­erkennung, Empfehlungen." },
            { title: "Computer Vision", desc: "Objekt­erkennung, OCR, Qualitätskontrolle, Gesichts-/Bedrohungs­erkennung." },
            { title: "NLP", desc: "Sentiment, Topic Modeling, Übersetzung, Zusammenfassung." },
            { title: "KI-Tests & Bewertung", desc: "Genauigkeit, Bias, Sicherheit (Jailbreak) und Evaluation." },
            { title: "MLOps & Data Pipelines", desc: "Deployment, Monitoring, Re-Training und Datenmanagement." },
            { title: "Data Engineering & Analytics", desc: "Data Warehouses, ETL, Echtzeit-Analytics, BI-Dashboards." },
          ],
        },
      ],
      cta: { title: "Stärken wir Ihre Technologie.", body: "Erzählen Sie uns Ihre Anforderungen — wir planen ein kostenloses Discovery-Gespräch.", button: "Kontakt" },
    },
  },

  // ─────────────────────────────────────────────────────────── FR
  fr: {
    construction: {
      eyebrow: "CONSTRUCTION",
      hero: {
        title: "Solutions de construction corporate, du design à la livraison.",
        subtitle: "Design, conseil, ingénierie et fabrication sous un même toit pour des projets résidentiels, commerciaux et industriels.",
        cta: "Partagez votre brief",
      },
      services: {
        title: "Nos services de construction",
        lead: "Une gestion disciplinée à chaque étape, aux standards internationaux.",
        items: [
          { key: "design", title: "Design", desc: "Concept architectural, design d'intérieur, paysage et visualisation — équilibre entre esthétique, fonction et durabilité.", features: ["Concept architectural & avant-projet", "Architecture intérieure", "Paysage & design extérieur", "Visualisation 3D & rendu", "Conception lumière & acoustique"] },
          { key: "consulting", title: "Conseil", desc: "Faisabilité, permis, conseil en gestion de projet, gestion des contrats et des risques pour sécuriser votre investissement.", features: ["Faisabilité & analyse des coûts", "Permis & conseil réglementaire", "Conseil en gestion de projet (PMC)", "Gestion des contrats et appels d'offres", "Supervision risques & qualité"] },
          { key: "engineering", title: "Ingénierie", desc: "Structure, mécanique, électricité et infrastructure avec coordination intégrée basée sur le BIM.", features: ["Structure & béton armé", "MEP (CVC, plomberie)", "Électricité & courants faibles", "Coordination BIM", "Analyses et notes de calcul"] },
          { key: "manufacturing", title: "Fabrication", desc: "Charpentes métalliques, éléments préfabriqués, façades et mobilier sur mesure ; installation sur site incluse.", features: ["Fabrication de charpentes métalliques", "Éléments préfabriqués", "Façades et menuiseries", "Mobilier et décoration sur mesure", "Installation et mise en service"] },
        ],
      },
      cta: { title: "Parlons de votre projet.", body: "Partagez votre brief — notre équipe revient avec une faisabilité technique et une proposition sous 1 jour ouvré.", button: "Nous contacter" },
    },
    export: {
      eyebrow: "EXPORTATION",
      hero: {
        title: "Un pont fiable entre les produits turcs et les acheteurs internationaux.",
        subtitle: "Nous sourçons, qualifions et achetons des produits d'origine turque pour le compte d'acheteurs étrangers — opérations export de bout en bout.",
        cta: "Formulaire",
      },
      services: {
        title: "Nos services d'export",
        lead: "Sourcing professionnel depuis la Türkiye pour les acheteurs étrangers.",
        items: [
          { title: "Recherche & Sourcing", desc: "Nous recherchons des produits d'origine turque et présélectionnons les meilleurs fabricants et fournisseurs." },
          { title: "Vérification fournisseurs", desc: "Visites sur site, contrôle de la solidité financière, vérification des certifications et références." },
          { title: "Achats & échantillons", desc: "Approvisionnement d'échantillons, négociation, optimisation des prix, conditions de paiement et contrats." },
          { title: "Contrôle qualité & audit", desc: "QC pré-production, en production et avant expédition (audits ISO)." },
          { title: "Opérations d'export", desc: "Douane, logistique, assurance, crédoc et fret international — gestion complète." },
          { title: "Documentation & conformité", desc: "Certificat d'origine, facture, liste de colisage, ATR/EUR.1, certificats sanitaires et de conformité." },
        ],
      },
      form: {
        title: "Formulaire de demande",
        lead: "Partagez les détails des produits ou services nécessaires — nous préparons une proposition sur mesure.",
        labels: { fullName: "Nom complet", email: "E-mail", phone: "Téléphone", company: "Entreprise", country: "Votre pays", productCategory: "Catégorie de produit", productDetails: "Détails / spécification", quantity: "Quantité", targetMarket: "Marché cible", timeline: "Délai", budgetRange: "Budget (optionnel)", notes: "Notes complémentaires" },
        placeholders: { productCategory: "Ex. textile, alimentaire, machines, mobilier, matériaux...", productDetails: "Décrivez le produit, le niveau de qualité et les préférences de marque.", quantity: "Ex. 1 000 unités/mois, 20 tonnes, 1 conteneur", timeline: "Ex. 4-6 semaines", budgetRange: "Ex. 50 000 - 100 000 USD" },
        submit: "Envoyer la demande", submitting: "Envoi...",
        successTitle: "Demande reçue", successBody: "Notre équipe export reviendra avec une proposition détaillée sous 1 jour ouvré.",
        errorTitle: "Une erreur est survenue", errorBody: "Veuillez réessayer.",
        confidential: "Vos informations commerciales restent strictement confidentielles.",
      },
    },
    technology: {
      eyebrow: "TECHNOLOGIE",
      hero: {
        title: "Cybersécurité, logiciel et IA — un seul partenaire technologique.",
        subtitle: "Du pentest et tests DDoS au logiciel d'entreprise, en passant par l'IA et la qualité — une stack technologique complète.",
        cta: "Échangeons",
      },
      categories: [
        {
          key: "cyber", title: "Cybersécurité & Pentest",
          lead: "Nous testons votre infrastructure avec un état d'esprit attaquant et renforçons vos défenses.",
          items: [
            { title: "Pentest Web", desc: "OWASP Top 10 et au-delà : SQLi, XSS, RCE, IDOR, SSRF, authentification." },
            { title: "Pentest Mobile", desc: "iOS / Android : reverse engineering, détection jailbreak/root, sécurité du stockage." },
            { title: "Pentest Réseau", desc: "Pentest interne et externe, segmentation, analyse Active Directory." },
            { title: "Pentest API", desc: "Autorisation, rate limiting et fuites de données sur REST/GraphQL." },
            { title: "Tests DDoS & résilience", desc: "Scénarios DDoS volumétriques, protocolaires et applicatifs." },
            { title: "Sécurité Cloud (AWS/Azure/GCP)", desc: "Audits IAM, S3/Blob/GCS, KMS et conformité CIS." },
            { title: "Red Team & simulation d'adversaire", desc: "Simulations basées sur MITRE ATT&CK et tests TTP." },
            { title: "Ingénierie sociale & phishing", desc: "Phishing ciblé, spear-phishing, vishing et mesure de la sensibilisation." },
            { title: "SAST", desc: "Analyse statique, scan de secrets, analyse de composition (SCA)." },
            { title: "DAST & IAST", desc: "Tests dynamiques et interactifs en environnements live." },
            { title: "Gestion des vulnérabilités", desc: "Scan, priorisation, patch et vérification." },
            { title: "Services SOC / SIEM", desc: "Surveillance 24/7, collecte de logs, corrélation et alertes." },
            { title: "Réponse à incident & forensic", desc: "Analyse de malware, collecte de preuves numériques et reporting." },
            { title: "ISO 27001 / KVKK / GDPR", desc: "Analyse d'écart, politiques, procédures et préparation à l'audit." },
            { title: "SDLC sécurisé & DevSecOps", desc: "Intégration sécurité dans CI/CD et sécurité IaC." },
          ],
        },
        {
          key: "software", title: "Développement logiciel",
          lead: "Web, mobile et logiciel d'entreprise — moderne, scalable, sécurisé.",
          items: [
            { title: "Développement Web", desc: "Sites corporate, e-commerce, headless CMS, performants (Lighthouse 90+)." },
            { title: "Apps mobiles", desc: "iOS, Android et cross-platform (React Native / Flutter)." },
            { title: "Apps Web", desc: "SaaS, dashboards, portails B2B, applications temps réel." },
            { title: "Logiciel d'entreprise & ERP", desc: "ERP, CRM personnalisés et intégrations workflow." },
            { title: "API & microservices", desc: "REST, GraphQL, gRPC ; event-driven et service mesh." },
            { title: "Cloud & DevOps", desc: "Kubernetes, Docker, CI/CD, IaC (Terraform), observabilité." },
            { title: "Modernisation", desc: "Refactoring du legacy et migration cloud." },
            { title: "Protection & licensing", desc: "Anti-tamper, obfuscation, DRM, serveurs de licence." },
          ],
        },
        {
          key: "qa", title: "Tests & QA",
          lead: "Chaque scénario, chaque charge, chaque cas limite validé avant la production.",
          items: [
            { title: "Tests manuels & exploratoires", desc: "Tests manuels par scénario menés par des QA expérimentés." },
            { title: "Automatisation", desc: "End-to-end avec Selenium, Cypress, Playwright, Appium." },
            { title: "Performance & charge", desc: "Scénarios réalistes avec JMeter, k6, Locust." },
            { title: "Tests de sécurité", desc: "OWASP, ZAP, Burp Suite." },
            { title: "Tests d'API", desc: "Fonctionnels et intégration avec Postman, REST Assured, Karate." },
            { title: "Mobile Device Lab", desc: "Compatibilité iOS/Android sur un parc de devices réels." },
            { title: "Accessibilité (a11y)", desc: "Conformité WCAG 2.1 / 2.2 AA et plan de remédiation." },
            { title: "UAT", desc: "Planification et exécution avec les équipes métier." },
            { title: "Régression", desc: "Stratégie de régression intelligente et assurance des releases." },
          ],
        },
        {
          key: "ai", title: "IA & Données",
          lead: "IA générative, machine learning et données — construisez le futur dès aujourd'hui.",
          items: [
            { title: "IA Générative (GenAI)", desc: "Chatbots, assistants et systèmes de génération de contenu basés sur LLM." },
            { title: "RAG & assistants de connaissance", desc: "Moteurs de recherche personnalisés combinant votre base et des LLMs." },
            { title: "Machine Learning", desc: "Prévision, classification, détection d'anomalies, recommandation." },
            { title: "Computer Vision", desc: "Détection d'objets, OCR, contrôle qualité, reconnaissance faciale/menaces." },
            { title: "NLP", desc: "Analyse de sentiment, topic modeling, traduction, résumé." },
            { title: "Tests & évaluation IA", desc: "Précision, biais, sécurité (jailbreak) et évaluation." },
            { title: "MLOps & pipelines", desc: "Déploiement, monitoring, ré-entraînement et gestion des données." },
            { title: "Data Engineering & analytics", desc: "Data warehouses, ETL, analytics temps réel, dashboards BI." },
          ],
        },
      ],
      cta: { title: "Renforçons votre technologie.", body: "Parlez-nous de vos besoins — nous planifierons un appel découverte gratuit.", button: "Nous contacter" },
    },
  },
};

export default PAGES;
